import type { CSSProperties } from 'react';

export const BettieGradientColor = {
  titleBackground: {
    light: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 270deg at 50% 50%, #94A5F9 0deg, #5CDBF6 108.00000429153442deg, #FFE175 180deg, #D671F6 288.0000042915344deg, #9F9DF9 360deg)',
      opacity: 0.4,
      filter: 'blur(26.899999618530273px)'
    },
    dark: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.59999871253967deg, #03D3FF 232.19999313354492deg, #E5B400 360deg)',
      opacity: 0.4,
      filter: 'blur(26.899999618530273px)'
    }
  },
  // Outline 배경(1px 테두리) 그라데이션
  bettieProductOutline: {
    light: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 270deg at 50% 50%, #94A5F9 0deg, #5CDBF6 108.00000429153442deg, #FFE175 180deg, #D671F6 288.0000042915344deg, #9F9DF9 360deg)'
    },
    dark: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.59999871253967deg, #03D3FF 232.19999313354492deg, #E5B400 360deg)'
    }
  },
  // 카드 내부(Fill) 그라데이션
  bettieProductFill: {
    light: {
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.68) 100%), radial-gradient(50% 50% at 50% 50%, #FFF 0%, rgba(255, 255, 255, 0.4) 100%), conic-gradient(from 135deg at 50% 50%, rgba(255, 239, 181, 0.35) 0deg, rgba(234, 176, 250, 0.35) 102.59999871253967deg, rgba(144, 236, 255, 0.35) 232.19999313354492deg, rgba(255, 239, 181, 0.35) 360deg)'
    },
    dark: {
      background:
        'linear-gradient(0deg, rgba(0, 0, 0, 0.90) 0%, rgba(0, 0, 0, 0.90) 100%), radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.59999871253967deg, #03D3FF 232.19999313354492deg, #E5B400 360deg)'
    }
  },
  pulsingGradientCircle: {
    light: {
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.58) 0%, rgba(255, 255, 255, 0.58) 100%), radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 270deg at 50% 50%, rgba(148, 165, 249, 0.64) 0deg, rgba(92, 219, 246, 0.64) 108.00000429153442deg, rgba(255, 225, 117, 0.64) 180deg, rgba(214, 113, 246, 0.64) 288.0000042915344deg, rgba(159, 157, 249, 0.64) 360deg)'
    },
    dark: {
      background:
        'linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.59999871253967deg, #03D3FF 232.19999313354492deg, #E5B400 360deg)'
    }
  },
  glassCircle: {
    light: {
      background:
        'linear-gradient(136deg, rgba(255, 255, 255, 0.00) -30.31%, rgba(255, 255, 255, 0.67) 82.04%)'
    },
    dark: {
      background: 'linear-gradient(136deg, rgba(0, 0, 0, 0.00) -30.31%, rgba(0, 0, 0, 0.30) 82.04%)'
    }
  }
};

const commonBackgroundBorder: CSSProperties = {
  top: '-15px',
  height: 'calc(100% + 15px)',
  backdropFilter: 'blur(9px)',
  WebkitBackdropFilter: 'blur(9px)',
  filter: 'blur(1.65px)',
  maskImage: 'linear-gradient(to bottom, transparent 0px, black 20px)',
  WebkitMaskImage: 'linear-gradient(to bottom, transparent 0px, black 20px)',
  pointerEvents: 'none'
};

export const commonFontFamily: CSSProperties = {
  fontFamily: '"Noto Serif KR", ui-serif, Georgia, "Times New Roman", serif'
};

export const BettieLetterStyle = {
  fanLetterCard: {
    light: {
      background:
        'linear-gradient(92deg, rgba(255, 255, 255, 0.50) 31.85%, rgba(255, 255, 255, 0.10) 102.92%)',
      boxShadow: '0 0 4px 0 rgba(159, 23, 75, 0.07), 0 0 10.4px 0 rgba(159, 23, 75, 0.05)'
    },
    dark: {
      background:
        'linear-gradient(92deg, rgba(85, 85, 85, 0.50) 31.85%, rgba(85, 85, 85, 0.10) 102.92%)',
      boxShadow: '0 0 4px 0 rgba(159, 23, 75, 0.07), 0 0 10.4px 0 rgba(159, 23, 75, 0.05)'
    }
  },
  fanLetterMaskImage: {
    maskImage:
      'linear-gradient(180deg, #000 72.91%, rgba(0, 0, 0, 0.20) 86.41%, rgba(0, 0, 0, 0.00) 99.83%)',
    WebkitMaskImage:
      'linear-gradient(180deg, #000 72.91%, rgba(0, 0, 0, 0.20) 86.41%, rgba(0, 0, 0, 0.00) 99.83%)'
  },
  profileBorder: {
    ...commonFontFamily,
    backgroundImage:
      'linear-gradient(to bottom, transparent, transparent calc(27px - 1px), rgba(0, 0, 0, 0.08) calc(27px - 1px))',
    backgroundSize: '100% 27px',
    backgroundPosition: '0 28px',
    paddingBottom: '80px'
  },
  backgroundBorder: {
    light: {
      backgroundColor: 'rgba(255, 255, 255, 0.01)',
      ...commonBackgroundBorder
    },
    dark: {
      backgroundColor: 'rgba(0, 0, 0, 0.01)',
      ...commonBackgroundBorder
    }
  },
  priceBadgeBackground: {
    light: {
      background:
        'linear-gradient(92deg, rgba(255, 255, 255, 0.50) 31.85%, rgba(255, 255, 255, 0.10) 102.92%)'
    },
    dark: {
      background:
        'linear-gradient(92deg, rgba(34, 34, 34, 0.50) 31.85%, rgba(34, 34, 34, 0.10) 102.92%)'
    }
  },
  fabButtonBlur: {
    light: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 270deg at 50% 50%, #94A5F9 0deg, #5CDBF6 108.00000429153442deg, #FFE175 180deg, #D671F6 288.0000042915344deg, #9F9DF9 360deg)',
      filter: 'blur(5.8px)'
    },
    dark: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.59999871253967deg, #03D3FF 232.19999313354492deg, #E5B400 360deg)',
      filter: 'blur(5.8px)'
    }
  },
  fabButtonBackground: {
    background:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.60) 100%), radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from -49deg at 48.54% 46.15%, #94A5F9 0deg, #5CDBF6 108.00000429153442deg, #FFE175 180deg, #D671F6 288.0000042915344deg, #9F9DF9 360deg)',
    boxShadow:
      '0 0 1.8px 0 rgba(0, 0, 0, 0.08) inset, 0 0 2px 0 rgba(0, 0, 0, 0.05), 0 0 4px 0 rgba(0, 0, 0, 0.12), 0 0 5.3px 0 #FFF inset'
  },
  lineThrough: {
    light: {
      width: '35px',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.35)'
    },
    dark: {
      width: '35px',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(255, 255, 255, 0.35)'
    }
  }
};
